export default __webpack_public_path__ + "static/do3-d55d96c43cc62d08f80af7f808f555ba.png";